/* Saige Gift — theme scripts */
(function () {
  'use strict';

  var body = document.body;
  var overlay = document.querySelector('[data-overlay]');
  var openPanel = null;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var format = window.moneyFormat || '{{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, amount);
  }

  /* Panels: cart drawer, search, mobile menu ------------------------------ */

  function showOverlay() {
    if (!overlay) return;
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
  }

  function hideOverlay() {
    if (!overlay) return;
    overlay.classList.remove('is-visible');
    setTimeout(function () { overlay.hidden = true; }, 250);
  }

  function openPanelEl(el) {
    if (!el) return;
    closePanel();
    openPanel = el;
    el.classList.add('is-open');
    el.removeAttribute('hidden');
    body.style.overflow = 'hidden';
    showOverlay();
    var focusable = el.querySelector('input, button, a');
    if (focusable) setTimeout(function () { focusable.focus(); }, 120);
  }

  function closePanel() {
    if (!openPanel) return;
    openPanel.classList.remove('is-open');
    openPanel = null;
    body.style.overflow = '';
    hideOverlay();
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-open-panel]');
    if (opener) {
      event.preventDefault();
      openPanelEl(document.querySelector(opener.getAttribute('data-open-panel')));
      return;
    }
    if (event.target.closest('[data-close-panel]') || event.target.hasAttribute('data-overlay')) {
      closePanel();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePanel();
  });

  /* Cart ------------------------------------------------------------------ */

  function updateCartUI() {
    return fetch(window.routes.cart_url + '?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-drawer-inner]');
        var current = document.querySelector('[data-cart-drawer-inner]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .then(function () { return fetch(window.routes.cart_url + '.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (node) {
          node.textContent = cart.item_count;
          node.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      });
  }

  window.SaigeCart = { refresh: updateCartUI, formatMoney: formatMoney };

  /* Add to cart ----------------------------------------------------------- */

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-product-form]');
    if (!form) return;
    if (!document.body.hasAttribute('data-cart-drawer')) return;

    /* Shopify's AJAX cart cannot carry an uploaded file. When one is attached,
       step aside and let the browser POST the form to /cart/add normally —
       the shopper lands on the cart page instead of the drawer opening. */
    var fileInputs = form.querySelectorAll('input[type="file"]');
    for (var f = 0; f < fileInputs.length; f++) {
      if (fileInputs[f].files && fileInputs[f].files.length) return;
    }

    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }

    /* No Content-Type header — the browser sets the multipart boundary. */
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        return updateCartUI();
      })
      .then(function () {
        openPanelEl(document.querySelector('#CartDrawer'));
      })
      .catch(function (error) {
        var note = form.querySelector('[data-form-error]');
        if (note) { note.textContent = error.message; note.hidden = false; }
      })
      .finally(function () {
        if (button) { button.disabled = false; button.textContent = original; }
      });
  });

  /* File upload field ----------------------------------------------------- */

  document.addEventListener('change', function (event) {
    var input = event.target.closest ? event.target.closest('[data-upload-input]') : null;
    if (!input) return;
    var box = input.closest('.upload-field__box');
    var out = box ? box.querySelector('[data-upload-filename]') : null;
    if (!out) return;
    var picked = input.files && input.files.length ? input.files[0].name : '';
    out.textContent = picked;
    out.hidden = !picked;
  });

  /* Quantity steppers ----------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-quantity-step]');
    if (!step) return;
    var wrapper = step.closest('.quantity');
    var input = wrapper.querySelector('input');
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var value = parseInt(input.value, 10) || min;
    value += step.getAttribute('data-quantity-step') === 'up' ? 1 : -1;
    if (value < min) value = min;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart line item changes ------------------------------------------------ */

  function changeLine(line, quantity, scope) {
    if (scope) scope.style.opacity = '0.5';
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        return updateCartUI();
      });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    changeLine(input.getAttribute('data-line'), parseInt(input.value, 10), input.closest('.cart-item'));
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    changeLine(remove.getAttribute('data-line'), 0, remove.closest('.cart-item'));
  });

  /* Cart note ------------------------------------------------------------- */

  var noteTimer;
  document.addEventListener('input', function (event) {
    var note = event.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(window.routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }, 500);
  });

  /* Product gallery ------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var feature = gallery.querySelector('[data-gallery-feature] img');
    var image = thumb.querySelector('img');
    if (feature && image) {
      feature.src = image.getAttribute('data-full') || image.src;
      feature.srcset = '';
      feature.alt = image.alt;
    }
  });

  /* Variant selection ----------------------------------------------------- */

  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var variants = JSON.parse(picker.querySelector('[data-variant-json]').textContent);
    var form = document.querySelector('#' + picker.getAttribute('data-form-id'));

    picker.addEventListener('change', function () {
      var selected = Array.from(picker.querySelectorAll('input:checked')).map(function (i) { return i.value; });
      var match = variants.find(function (variant) {
        return variant.options.every(function (option, index) { return option === selected[index]; });
      });

      var idInput = form.querySelector('[name="id"]');
      var submit = form.querySelector('[type="submit"]');
      var priceEl = document.querySelector('[data-product-price]');

      if (!match) {
        submit.disabled = true;
        submit.textContent = 'Unavailable';
        return;
      }

      idInput.value = match.id;
      submit.disabled = !match.available;
      submit.textContent = match.available ? 'Add to Cart' : 'Sold out';
      if (priceEl) priceEl.innerHTML = formatMoney(match.price);

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }

      if (match.featured_image) {
        var feature = document.querySelector('[data-gallery-feature] img');
        if (feature) { feature.src = match.featured_image.src; feature.srcset = ''; }
      }
    });
  });

  /* Video modal ----------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-video-open]');
    if (trigger) {
      event.preventDefault();
      var modal = document.querySelector(trigger.getAttribute('data-video-open'));
      if (modal) {
        modal.hidden = false;
        body.style.overflow = 'hidden';
        var frame = modal.querySelector('iframe[data-src]');
        if (frame && !frame.src) frame.src = frame.getAttribute('data-src');
        var clip = modal.querySelector('video');
        if (clip) {
          var playing = clip.play();
          if (playing && playing.catch) playing.catch(function () {});
        }
      }
      return;
    }
    var closer = event.target.closest('[data-video-close]');
    if (closer || event.target.classList.contains('video-modal')) closeVideoModal();
  });

  function closeVideoModal() {
    var open = document.querySelector('.video-modal:not([hidden])');
    if (!open) return;
    open.hidden = true;
    body.style.overflow = '';
    var video = open.querySelector('video');
    if (video) { video.pause(); video.currentTime = 0; }
    var iframe = open.querySelector('iframe');
    if (iframe) { iframe.src = iframe.src; }
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeVideoModal();
  });

  /* Collection sort ------------------------------------------------------- */

  var sortSelect = document.querySelector('[data-sort-by]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* Grid view switcher ---------------------------------------------------- */

  /* The choice is remembered, so someone who wants bigger images keeps them as
     they page through a collection. Only '2' and '3' are ever stored. */
  var GRID_VIEW_KEY = 'saige:grid-view';

  function storedGridView() {
    try {
      var value = window.localStorage.getItem(GRID_VIEW_KEY);
      return value === '2' || value === '3' ? value : null;
    } catch (error) {
      return null;
    }
  }

  document.querySelectorAll('[data-grid-view]').forEach(function (switcher) {
    var grid = document.getElementById(switcher.getAttribute('data-grid-view'));
    if (!grid) return;

    var buttons = switcher.querySelectorAll('[data-view-value]');
    var chosen = storedGridView();
    var resizeTimer = null;

    function apply() {
      if (chosen) {
        grid.setAttribute('data-view', chosen);
      } else {
        /* Untouched, the grid keeps the theme's own responsive steps — so read
           back what it is actually rendering to light the matching button. */
        grid.removeAttribute('data-view');
      }
      var showing = chosen || String(window.getComputedStyle(grid).gridTemplateColumns.split(' ').length);
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-view-value') === showing ? 'true' : 'false');
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        chosen = button.getAttribute('data-view-value');
        try { window.localStorage.setItem(GRID_VIEW_KEY, chosen); } catch (error) {}
        apply();
      });
    });

    window.addEventListener('resize', function () {
      if (chosen) return;
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(apply, 150);
    });

    apply();
  });
})();
